import React from 'react';
import Wats from '../../assets/whats.png';
import formatDate from '../../helpers/formatDate';
import './styles.scss'
import sendMessage from '../../helpers/sendWatsappMessage';

function Card(props) {

  const { endereco, contatos, horario } = props.data;

  const compareHours = () => {

    const actualTime = new Date();
    const finalData = new Date(horario.final)

    if (actualTime.getDate() !== finalData.getDate()) {
      return false;
    }

    const actualHour = actualTime.getHours();
    const finalHour = finalData.getHours();

    if ( (finalHour - actualHour) <= 2 ) {
      return true;
    } 
    
    return false

  }

  return (
    <div className="card">
      <h1>{props.data.name}</h1>
      <div className='info'>
          <span>{`Horário de funcionamento: ${formatDate(horario.inicio, horario.inicio)} - ${formatDate(horario.final, horario.inicio)}`}</span>
          <span>
            {
              `${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}`
            }
          </span>
          <span>{`Telefone: ${contatos.tel}`}</span>
        
      </div>
      <div className='footer'>.
      { 

        compareHours() ? (  <small className='alert'>FECHANDO EM BREVE</small>) : null
      }
    
        <div>
          <button onClick={() => sendMessage( contatos.whatsapp ? contatos.whatsapp : contatos.tel  )} className='contact'>
            <img src={Wats} alt="Whatsapp" />
            <span>Entre em contato</span>
          </button>
        </div>  
      </div>
    </div>
  );
}

export default Card;